/* Fetch content of Creek /page */

const events = require('../core/events');
const fetch = require('../helpers/fetch');

const pages = {
  fetch: function fetchPage(path) {
    fetch.get(path, { headers: { 'x-bff-content-update': '1' } }, {
      success: function (domResponse) {
        document.dispatchEvent(new CustomEvent(events.dataHtmlPage, {
          detail: domResponse
        }));
      },
      failure: function currentTrackFailed(e) {
        console.warn(e);
      }
    });
  }
};

module.exports = pages;



//////////////////
// WEBPACK FOOTER
// ./src/js/data/htmlPage.js
// module id = 92
// module chunks = 0